import { render, staticRenderFns } from "./ski-resort-tab-partial.vue?vue&type=template&id=33413669"
import script from "./ski-resort-tab-partial.vue?vue&type=script&lang=js"
export * from "./ski-resort-tab-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports